angular
    .module('app')
    .component('winbackCampaignsEdit', {
        templateUrl: '/templates/pages/winback-campaigns/winback-campaigns-edit/winback-campaigns-edit.html',
        controller: 'WinbackCampaignsEditController',
        controllerAs: 'vm',
    });